import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { G4PositionsEdit } from "./edit";
import { G4PositionsNew } from "./new";
import { G4PositionsTable } from "./table";

export default function G4Positions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Positions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<G4PositionsEdit />} />
      <Route index element={<G4PositionsTable />} />
      <Route path="new" element={<G4PositionsNew />} />
    </Routes>
  );
}
